import { render, staticRenderFns } from "./AssignClerksModal.vue?vue&type=template&id=feefe534&scoped=true"
import script from "./AssignClerksModal.vue?vue&type=script&lang=js"
export * from "./AssignClerksModal.vue?vue&type=script&lang=js"
import style0 from "./AssignClerksModal.vue?vue&type=style&index=0&id=feefe534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feefe534",
  null
  
)

export default component.exports